import { Layouts } from './layout'

export default Layouts
